import React from 'react';
import * as FIcons from 'react-icons/fi'
import { Link } from 'react-router-dom';
import classes from './NavCard.module.css'

interface INavCardProps {
    title: string,
    iconName: string,
    to: string
}


const NavCard: React.FC<INavCardProps> = (props)=>{

    let Icon
    if(props.iconName)
      Icon = FIcons[props.iconName as keyof typeof FIcons]
    

    return(
        <Link to={props.to} className={classes.homeNavCard}>
           {Icon && <Icon color='#fff' size={30}/>}
            <p style={{color: '#fff', fontWeight: 'bold', marginLeft: 15}}>{props.title}</p>
        </Link>
    )
}

export default NavCard